import { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { LW_GATEWAY_NAME_MESSAGE, DEV_EUI_MESSAGE, Patterns } from "constant";
import { GATEWAY_ROUTES } from "constant/gateway";
import { isHttpSuccess } from "utils/functions";
import ContentWrapper from "components/content-wrapper/ContentWrapper";
import { showSuccessAlert, showErrorAlert, getAPIError } from "utils/alert";
import { addLoRaWANNode } from "service/gatewayService";

const AddLoRaWANNode = () => {
    const history = useHistory();
    const [gatewayName, setGatewayName] = useState("");
    const [devEUI, setDevEUI] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const isValidGatewayName = useMemo(
        () => Patterns.gatewayNamePattern.test(gatewayName.trim()),
        [gatewayName]
    );

    const isValidDevEUI = useMemo(
        () => devEUI === devEUI.trim() && Patterns.devEUIPattern.test(devEUI),
        [devEUI]
    );

    const isFormValid = useMemo(
        () => isValidGatewayName && isValidDevEUI,
        [isValidGatewayName, isValidDevEUI]
    );

    const handleSaveLoRaWANNode = async () => {
        if (!isFormValid) return;

        setIsLoading(true);
        try {
            const response = await addLoRaWANNode(
                devEUI.trim(),
                gatewayName.trim()
            );

            if (isHttpSuccess(response.status)) {
                showSuccessAlert({
                    message: "Gateway has been added successfully.",
                });
                history.push(GATEWAY_ROUTES.GATEWAYS_ALL);
            } else {
                showErrorAlert(
                    getAPIError(
                        response,
                        "Adding a new LoRaWAN node has failed."
                    )
                );
            }
        } catch (error: any) {
            showErrorAlert(
                getAPIError(error, "Adding a new LoRaWAN node has failed.")
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ContentWrapper>
            <div className="page-content">
                <Container>
                    <Row>
                        <Col sm="12">
                            <h5 className="page-title">Add LoRaWAN Node</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <Form className="d-inline-block w-100">
                                <div className="form-box">
                                    <Form.Group className="mb-4">
                                        <Form.Label>Gateway Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            required
                                            name="gatewayName"
                                            aria-label="gateway-name"
                                            placeholder="My LoRaWAN Gateway 1"
                                            isInvalid={
                                                !!gatewayName.trim() &&
                                                !isValidGatewayName
                                            }
                                            value={gatewayName}
                                            onChange={(e) =>
                                                setGatewayName(e.target.value)
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {LW_GATEWAY_NAME_MESSAGE}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label>DevEUI</Form.Label>
                                        <Form.Control
                                            type="text"
                                            required
                                            name="devEUI"
                                            aria-label="dev-eui"
                                            placeholder="AABBCCDDEEFF0011"
                                            isInvalid={
                                                !!devEUI && !isValidDevEUI
                                            }
                                            value={devEUI}
                                            onChange={(e) =>
                                                setDevEUI(e.target.value)
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {DEV_EUI_MESSAGE}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                            </Form>
                            <Button
                                variant="secondary"
                                className="mt-4 mr-2"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                CANCEL
                            </Button>
                            <Button
                                variant="primary"
                                className="mt-4"
                                onClick={handleSaveLoRaWANNode}
                                disabled={!isFormValid || isLoading}
                            >
                                SAVE
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </ContentWrapper>
    );
};

export default AddLoRaWANNode;
